export enum TokenType {
  Fungible = 'fungible',
  NonFungible = 'nonFungible',
}
